export const serviceImages = {
  ai: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/ai-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/ai-list-icons.webp",
  },
  webapp: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/web-app-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/web-list-icons.webp",
  },
  blockchain: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/blockchain-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/blockchain-list-icons.webp",
  },
  cloud: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/cloud-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/cloud-list-icons.webp",
  },
  robotic: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/rpa-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/robotic-list-icons.webp",
  },
  devops: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/business-intelligence-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/devops-list-icons.webp",
  },
  ml: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/ml-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/ml-list-icons.webp",
  },
  android: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/android-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/android-list-icons.webp",
  },
  iot: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/iot-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/iot-list-icons.webp",
  },
  ios: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/banners/ios-hero.webp",
    list: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/software-icons/ios-list-icons.webp",
  },
};
